import { atom } from 'recoil';
import { IItemData } from '../../../game-server/src/modules/items/items.interface';

export const marketplaceItemAtom = atom({ key: 'marketplaceItemAtom', default: null as null | IItemData['id'] });
